import React, { Component, Fragment } from "react";
import Port from "../port";
import { FullscreenExitOutlined } from "@ant-design/icons";

class PortsRender extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  portRender = (expandComp) => {
    const { components, libraries, portsObj, fixed, lastOpenModel, model } = this.props;
    const usedPorts = components.map(item => item.pins.map(pin => pin.model || {})).flat(3).filter(item => item.port);
    return <Fragment>
      {(expandComp.pins || []).map((item) => (
        <Fragment key={`${item.comp}::${item.pin}`}>
          {!item.hideTitle ? <div className="port-select port-select-title"
            style={{
              left: item.textX || item.x,
              top: item.textDir === "bottom" ? (item.textY ? item.textY + 18 : item.y + 18) : item.textY || item.y,
              color: item.color
            }}>
            {item.pinTitle}
          </div> : null}
          <div className={expandComp.isSeries && ["left", "right"].includes(item.dir) ? "port-select rlc-port-select" : "port-select"}
            style={{
              left: item.x,
              top: item.textDir === "bottom" ? item.y : item.y + 18
            }}>
            <Port
              pin={{ ...item, pinName: item.pin }}
              index={`${item.comp}::${item.pin}`}
              libraries={libraries}
              portsObj={portsObj}
              usedPorts={usedPorts}
              model={model}
              modelType={model.modelType}
              lastOpenModel={lastOpenModel}
              saveModel={this.props.saveModel}
              selectOpenModel={this.props.selectOpenModel}
              fixed={fixed}
            />
          </div>
        </Fragment>
      ))}

    </Fragment>
  }

  render = () => {
    const { expandComps } = this.props;
    //closeIconLocation
    return <Fragment>
      {expandComps.map(comp => <Fragment key={comp.name}>
        {this.portRender(comp)}
        {comp.closeIconLocation ? /* <div className="sierra-pre-layout-schematic-full-icon" style={{ left: comp.closeIconLocation.x, top: comp.closeIconLocation.y }}> */
          <FullscreenExitOutlined
            title="Close ports assignment"
            className="sierra-pre-layout-schematic-full-icon"
            style={{ left: comp.closeIconLocation.x, top: comp.closeIconLocation.y }}
            onClick={(e) => this.props.closeExpandComp(e, comp)}
          /> /* </div> */ : null}
      </Fragment>)}
    </Fragment>
  }
}

export default PortsRender;